/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';

import { Spinner } from 'sarsaparilla';

import TertiaryContent from 'ui-permit/src/components/tertiaryContentPage/TertiaryContent';
import * as pActions from '../actions/permit';

export class TertiaryContentPage extends Component {
    static propTypes = {
        dispatch: PropTypes.func,
        id: PropTypes.string,
        name: PropTypes.string,
        additionalInformation: PropTypes.string,
    };

    static defaultProps = {
        additionalInformation: '',
        id: '',
        name: '',
    };

    componentDidMount() {
        if (this.props.id !== '233396') {
            this.refetchPermit();
        }
    }

    refetchPermit() {
        this.props.dispatch(pActions.fetchPermit('233396'));
    }

    render() {
        if (!this.props.id || this.props.id !== '233396') {
            return (
                <div className="permit-loading-wrapper">
                    <Spinner />
                </div>
            );
        }
        return (
            <div className="boundarywaters">
                <TertiaryContent
                    id={this.props.id}
                    name={this.props.name}
                    additionalInformation={this.props.additionalInformation}
                />
            </div>
        );
    }
}

function select(state) {
    return {
        id: get(state, 'boundarywaters.permit.result.id'),
        name: get(state, 'boundarywaters.permit.result.name'),
        additionalInformation: get(
            state,
            'boundarywaters.permit.result.description.tertiary_page'
        ),
    };
}

export default connect(select)(TertiaryContentPage);

// cSpell:ignore boundarywaters
